// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-nqzNG","body":"body-npZVT","modalTitle":"modalTitle-Q9aYe"};